import { Link, useLocation, useNavigate } from "react-router-dom";
import { Skull, LogOut } from "lucide-react";
import { useAuth } from "@/lib/auth";

export const SiteHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();
  const onCurator = location.pathname.startsWith("/curator");
  const onLogin = location.pathname.startsWith("/login");

  const handleSignOut = () => {
    logout();
    navigate("/");
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-30 backdrop-blur-xl bg-[#0f0c0b]/80 border-b border-[#e8aa42]/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-home-link"
          className="flex items-center gap-3 group"
        >
          <Skull className="w-5 h-5 text-[#e8aa42] candle-flicker" strokeWidth={1.25} />
          <span className="font-display text-xl md:text-2xl tracking-wide text-[#e2d6c8] group-hover:text-[#e8aa42] transition-colors duration-500">
            Vicky's Lost Girls
          </span>
        </Link>
        <nav className="flex items-center gap-6 md:gap-8 font-ui text-xs tracking-eerie uppercase text-[#a89f91]">
          <Link
            to="/"
            data-testid="nav-exhibit"
            className={`hover:text-[#e8aa42] transition-colors duration-500 ${!onCurator && !onLogin && location.pathname !== "/photography" ? "text-[#e2d6c8]" : ""}`}
          >
            Exhibit
          </Link>
          <Link
            to="/photography"
            data-testid="nav-photography"
            className={`hover:text-[#e8aa42] transition-colors duration-500 ${location.pathname === "/photography" ? "text-[#e2d6c8]" : ""}`}
          >
            Photography
          </Link>
          <Link
            to="/curator"
            data-testid="nav-curator"
            className={`hover:text-[#e8aa42] transition-colors duration-500 ${onCurator ? "text-[#e2d6c8]" : ""}`}
          >
            Curator
          </Link>
          {isAuthenticated && (
            <button
              data-testid="nav-signout"
              onClick={handleSignOut}
              className="inline-flex items-center gap-2 hover:text-[#e8aa42] transition-colors duration-500"
            >
              <LogOut className="w-3.5 h-3.5" strokeWidth={1.5} />
              Sign out
            </button>
          )}
        </nav>
      </div>
    </header>
  );
};

export default SiteHeader;
